export const roundToTwoDecimals = (number: number) => {
    if (!number)
        return number

    return Math.round(number * 100) / 100
}